var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mb-8",attrs:{"elevation":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }